const riot = require('riot');

riot.tag2('page-terms', '<div class="container-538 px24 pt24"> <div class="ts-hl mb24">個人情報の取り扱いについて</div> <p class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{terms}"></p> </div>', '', '', function(opts) {
    this.preload = async ({req}) => {
      var campaign_id = req.params.campaign_id;
      var { terms } = await app.api.child(`campaigns/${campaign_id}/terms`).get();

      return {
        terms,
      };
    };
});